import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import RingLoader from "react-spinners/ScaleLoader";

//componentes
import "./nomina.css";
import Alert from "../../modal/alert";
import { fetchSedes } from "../../utils/sedesApi";

const OPCIONES_IMPRESION_PRENOMINA = [
  { value: "1", label: "Opción 1 (15 y 30)" },
  { value: "2", label: "Opción 2 (5 y 20)" },
  { value: "3", label: "Opción 3 (10 y 25)" },
  { value: "4", label: "Opción 4 (Todas)" },
];

const esOpcionImpresionValida = (opcion) => {
  const op = parseInt(opcion, 10);
  return op >= 1 && op <= 4;
};

const etiquetaSede = (sede, sedes) => {
  if (String(sede) === "0") return "Todas las sucursales";
  const item = (sedes || []).find((s) => String(s.variable1) === String(sede));
  return item ? item.variable2 : String(sede || "");
};

const etiquetaImpresion = (opcion) => {
  const item = OPCIONES_IMPRESION_PRENOMINA.find(
    (o) => o.value === String(opcion)
  );
  return item ? item.label : "";
};

const etiquetaQuincena = (trimestre) => {
  if (String(trimestre) === "1") return "Primera Quincena";
  if (String(trimestre) === "2") return "Segunda Quincena";
  return "";
};

function ReporteDecimoE(props) {
  const [mensajealerta, setmensajealerta] = React.useState(false);
  const [paso, setpaso] = React.useState(false);
  const [loading, setloading] = React.useState(false);
  const [anio, setanio] = React.useState([]);
  const [mes, setmes] = React.useState([]);
  const [opcionR, setopcionR] = React.useState([]);
  const [tituloM, settituloM] = React.useState("");
  const [cuerpoM, setcuerpoM] = React.useState("");
  const [trimestre, settrimestre] = React.useState("");
  const [anopagar, setanopagar] = React.useState("");
  const [mesapagar, setmesapagar] = React.useState("");
  const [sede, setsede] = React.useState("");
  const [sedes, setSedes] = React.useState([]);
  const [diaImpresionReporte, setDiaImpresionReporte] = React.useState("");
  const [datosNoReporte, setdatosNoReporte] = React.useState([]);
  const datosNoReporteRef = React.useRef([]);

  const onChange = (e) => {
    let index = e.target.getAttribute("id");
    if (index === "trimestre") {
      settrimestre(e.target.value);
    }
    if (index === "anopagar") {
      setanopagar(e.target.value);
    }
    if (index === "mesapagar") {
      setmesapagar(e.target.value);
    }
    if (index === "opcionR") {
      setopcionR(e.target.value);
    }
    if (index === "sede") {
      setsede(e.target.value);
    }
    if (index === "diaImpresionReporte") {
      setDiaImpresionReporte(e.target.value);
    }
  };

  const validarFiltros = () => {
    if (sede === "" || sede === null || sede === undefined) {
      setmensajealerta(true);
      settituloM("Menu Pre-Nomina.");
      setcuerpoM("Debe seleccionar una Sede (o Todas).");
      return false;
    }
    if (!esOpcionImpresionValida(diaImpresionReporte)) {
      setmensajealerta(true);
      settituloM("Menu Pre-Nomina.");
      setcuerpoM(
        "Debe seleccionar el tipo de impresión (Opción 1, 2, 3 o 4)."
      );
      return false;
    }
    if (String(trimestre) !== "1" && String(trimestre) !== "2") {
      setmensajealerta(true);
      settituloM("Menu Pre-Nomina.");
      setcuerpoM("Debe seleccionar la Quincena.");
      return false;
    }
    if (!mesapagar || String(mesapagar) === "0") {
      setmensajealerta(true);
      settituloM("Menu Pre-Nomina.");
      setcuerpoM("Debe seleccionar el Mes a Pagar.");
      return false;
    }
    if (!anopagar || String(anopagar) === "0") {
      setmensajealerta(true);
      settituloM("Menu Pre-Nomina.");
      setcuerpoM("Debe seleccionar el Año a Pagar.");
      return false;
    }
    return true;
  };

  const mensajeConfirmacionFiltros = () => {
    const mesTxt =
      Array.isArray(mes) && mes.find((m) => String(m.variable1) === String(mesapagar))
        ? mes.find((m) => String(m.variable1) === String(mesapagar)).variable2
        : mesapagar;
    return (
      "Se recalculará SOLO la pre-nómina según estos filtros:\n\n" +
      "• Sede: " +
      etiquetaSede(sede, sedes) +
      "\n" +
      "• Impresión: " +
      etiquetaImpresion(diaImpresionReporte) +
      "\n" +
      "• Periodo: " +
      etiquetaQuincena(trimestre) +
      " / " +
      mesTxt +
      " / " +
      anopagar +
      "\n\n" +
      "Solo se eliminarán y recrearán datos que coincidan con esos parámetros.\n" +
      "Si existen datos de otras sedes u otras opciones de impresión, NO se modificarán ni se tomarán en cuenta en este proceso.\n\n" +
      "¿Desea continuar?"
    );
  };

  const generarPrenomina = () => {
    if (!validarFiltros()) return;
    if (!window.confirm(mensajeConfirmacionFiltros())) return;

    setloading(true);

    let data = new FormData();
    data.append("anoapagar", anopagar);
    data.append("trimestre", trimestre);
    data.append("mesapagar", mesapagar);
    data.append("sede", sede);
    data.append("diaImpresionReporte", diaImpresionReporte);
    data.append("usuario", props.usuario1.password);
    data.append("boton", "calcularPrenomina");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/prenomina.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        if (res.data.variable1) {
          if (res.data.variable2 === 1 && res.data.variable3 === res.data.variable4) {
            setmensajealerta(true);
            settituloM("Menu Pre-Nomina.");
            setcuerpoM("La quincena esta CERRADA, no afectara ningún cambio.");
          }
          if (res.data.variable2 === 1 && res.data.variable3 !== res.data.variable4) {
            setmensajealerta(true);
            settituloM("Menu Pre-Nomina.");
            setcuerpoM(
              "La quincena esta CERRADA, y existe una diferencia de registros entre lo guardado y lo consultado, y no se registrara ningún cambio."
            );
          }

          setpaso(true);
          const raw = res.data.variable5;
          const lista = Array.isArray(raw)
            ? raw
            : raw && typeof raw === "object"
            ? Object.values(raw)
            : [];
          datosNoReporteRef.current = lista;
          setdatosNoReporte(lista);
          setloading(false);
        } else {
          setpaso(false);
          setloading(false);
          setmensajealerta(true);
          settituloM("Menu Pre-Nomina.");
          setcuerpoM(
            res.data.variable2 ||
              "No se pudo generar la pre-nómina. Verifique los filtros."
          );
        }
      })
      .catch(() => {
        setloading(false);
        setmensajealerta(true);
        settituloM("Menu Pre-Nomina.");
        setcuerpoM("Error de conexión al generar la pre-nómina.");
      });
  };

  const otraConsulta = () => {
    setpaso(false);
    datosNoReporteRef.current = [];
    setdatosNoReporte([]);
  };

  const handleClose = () => {
    setmensajealerta(false);
  };

  const cargarFechas = () => {
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/fecha.php";
    axios.post(xurl).then((res) => {
      if (res.data.variable1) {
        let xmes = res.data.variable1;
        let xanio = res.data.variable2;
        setmes(xmes);
        setanio(xanio);
      }
    });
  };

  const buscarTipoReporte = () => {
    if (opcionR === "1") especialistaTodo();
    if (opcionR === "2") especialistaTotales();
    if (opcionR === "3") consultasSinReporte();
  };

  const consultasSinReporte = () => {
    const fromState = Array.isArray(datosNoReporte)
      ? datosNoReporte
      : datosNoReporte && typeof datosNoReporte === "object"
      ? Object.values(datosNoReporte)
      : [];
    const fromRef = Array.isArray(datosNoReporteRef.current)
      ? datosNoReporteRef.current
      : Object.values(datosNoReporteRef.current || {});
    const lista = fromState.length > 0 ? fromState : fromRef;
    if (lista.length === 0) {
      setmensajealerta(true);
      settituloM("Menu Pre-Nomina.");
      setcuerpoM("No hay datos de consultas sin reporte para generar el PDF.");
      return;
    }
    let data = new FormData();
    data.append("datos", JSON.stringify(lista));
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/citaSinReporte.php",
      responseType: "arraybuffer",
      data: data,
    })
      .then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      })
      .catch(() => {
        setmensajealerta(true);
        settituloM("Menu Pre-Nomina.");
        setcuerpoM("Error al generar el reporte PDF de consultas sin reporte.");
      });
  };
  const especialistaTotales = () => {
    if (!validarFiltros()) return;
    let data = new FormData();
    data.append("anoapagar", anopagar);
    data.append("trimestre", trimestre);
    data.append("mesapagar", mesapagar);
    data.append("sede", sede);
    data.append("diaImpresionReporte", diaImpresionReporte);
    data.append("usuario", props.usuario1.password);
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/prenominaTotales.php",
      responseType: "arraybuffer",
      data: data,
    }).then(function (response) {
      let blob = new Blob([response.data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
    });
  };
  const especialistaTodo = () => {
    if (!validarFiltros()) return;
    let data = new FormData();
    data.append("anoapagar", anopagar);
    data.append("trimestre", trimestre);
    data.append("mesapagar", mesapagar);
    data.append("sede", sede);
    data.append("diaImpresionReporte", diaImpresionReporte);
    data.append("usuario", props.usuario1.password);
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/prenomina.php",
      responseType: "arraybuffer",
      data: data,
    }).then(function (response) {
      let blob = new Blob([response.data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
    });
  };

  React.useEffect(() => {
    cargarFechas();
    fetchSedes().then(setSedes);
  }, []);

  return (
    <div className="principal-pago row">
      <div className="contenedor-cxc col-12">
        <div className="titulo-cxc ">
          <p>GENERAR PRE-NOMINA ESPECIALISTAS. </p>
        </div>
        {mensajealerta === true && (
          <Alert
            tituloMensaje={tituloM}
            cuerpoMensaje={cuerpoM}
            open={mensajealerta}
            handleClose={handleClose}
          />
        )}
        {loading && (
          <div className="cont-spinner row">
            <div className="spinner col-6">
              <RingLoader
                clasName="spinner"
                sizeUnit={"px"}
                size={160}
                width={19}
                radius={20}
                height={160}
                color={"#48e120"}
                loading={loading}
              />
            </div>
          </div>
        )}

        <div className="cont-listmedi row">
          <div className="cont-personal col-2">
            <label className="titulo-salario2">Sede.</label>

            <select id="sede" name="sede" value={sede} onChange={onChange}>
              <option value="">-Seleccione Sucursal-</option>
              {sedes.map((item) => (
                <option key={item.variable1} value={String(item.variable1)}>
                  {item.variable2}
                </option>
              ))}
              <option value="0">Todas</option>
            </select>
          </div>
          <div className="cont-personal col-3">
            <label className="titulo-salario2">
              Quincena a consultar.
              <select
                id="trimestre"
                name="trimestre"
                value={typeof trimestre !== "undefined" ? trimestre : ""}
                onChange={onChange}
              >
                <option value="">-Seleccione Quincena-</option>
                <option value="1">Primera Quincena.</option>
                <option value="2">Segunda Quincena.</option>
              </select>
            </label>
          </div>
          <div className="cont-personal col-2">
            <label className="titulo-salario2">
              Mes a Pagar.
              <select
                id="mesapagar"
                name="mesapagar"
                value={typeof mesapagar !== "undefined" ? mesapagar : ""}
                onChange={onChange}
              >
                <option value="">Mes a Pagar</option>
                {mes.map((item, i) => {
                  return (
                    <option key={i} value={item.variable1}>
                      {item.variable2}
                    </option>
                  );
                })}
              </select>
            </label>
          </div>
          <div className="cont-personal col-2">
            <label className="titulo-salario2">
              Año a Pagar.
              <select
                id="anopagar"
                name="anopagar"
                value={typeof anopagar !== "undefined" ? anopagar : ""}
                onChange={onChange}
              >
                <option value="">Año a Pagar</option>
                {anio.map((item, i) => {
                  return (
                    <option key={i} value={item.variable1}>
                      {item.variable1}
                    </option>
                  );
                })}
              </select>
            </label>
          </div>
          <div className="cont-personal col-3">
            <label className="titulo-salario2">
              Imprimir:
              <select
                id="diaImpresionReporte"
                name="diaImpresionReporte"
                value={diaImpresionReporte}
                onChange={onChange}
              >
                <option value="">Seleccione opción</option>
                {OPCIONES_IMPRESION_PRENOMINA.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </div>
        {}
        {paso === true && (
          <div className="cont-listmedi row">
            <div className="cont-personal col-4">
              <label className="titulo-salario2">
                Seleccione un Reporte.
                <select
                  id="opcionR"
                  name="opcionR"
                  value={typeof opcionR !== "undefined" ? opcionR : ""}
                  onChange={onChange}
                >
                  <option value="0"></option>
                  <option value="1">
                    especialistas por estudios Cobrados.
                  </option>
                  <option value="2">especialistas Totales.</option>
                  <option value="3">Terapias sin Reporte</option>
                </select>
              </label>
            </div>
            <div className="cont-personal col-4">
              <button className="botonN" onClick={buscarTipoReporte}>
                Imprimir
              </button>
            </div>
          </div>
        )}

        <div className="cont-personal col-12">
          {paso === false && (
            <button className="botonN" onClick={generarPrenomina}>
              Generar Pre-Nomina
            </button>
          )}
          {paso === true && (
            <button className="botonN" onClick={otraConsulta}>
              Otra Consulta
            </button>
          )}
          <button className="boton" onClick={props.personalClose}>
            Salir
          </button>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    usuario1: state.usuario1,
    token: state.token,
  };
};
export default connect(mapStateToProps)(ReporteDecimoE);
